<!--
 * @Description: 账户充值
 * @Date: 2025-05-20 15:57:04
-->

<template>
  <BaseDialog width="880px" title="对公账户充值">
    <BaseTextContent>
      <p
        style="
          font-size: 14px;
          color: #fa4d56;
          line-height: 22px;
          font-style: normal;
          text-transform: none;
          margin-bottom: 24px;
        "
      >
        入金账户 （此账户只用于充值使用）
      </p>
      <BaseForm
        style="grid-template-columns: repeat(2, 1fr)"
        label-position="top"
        :model="rechargeInfo"
      >
        <BaseFormItem label="户名" prop="companyName">
          <BaseInput
            style="width: 100%"
            type="text"
            disabled
            v-model="rechargeData.companyName"
          ></BaseInput>
        </BaseFormItem>
        <BaseFormItem label="账号" prop="bfBankNumber">
          <BaseInput
            type="text"
            style="width: 100%"
            disabled
            v-model="rechargeData.bfBankNumber"
          ></BaseInput>
        </BaseFormItem>
        <BaseFormItem label="开户行" prop="openBankName">
          <BaseInput
            type="text"
            style="width: 100%"
            disabled
            v-model="rechargeData.openBankName"
          ></BaseInput>
        </BaseFormItem>
        <BaseFormItem label="支行名称" prop="fySubBranchName">
          <BaseInput
            type="text"
            style="width: 100%"
            disabled
            v-model="rechargeData.fySubBranchName"
          ></BaseInput>
        </BaseFormItem>
        <BaseFormItem label="联行号" prop="openBankNode">
          <BaseInput
            type="text"
            style="width: 100%"
            disabled
            v-model="rechargeData.openBankNode"
          ></BaseInput>
        </BaseFormItem>
      </BaseForm>
      <p
        style="
          background: #ffefe5;
          box-sizing: border-box;
          padding: 8px;
          font-size: 14px;
          color: var(--xrk-color-primary);
          line-height: 22px;
          font-style: normal;
          text-transform: none;
        "
      >
        温馨提示：请通过网银将充值金额汇入对应账户，请切记使用对公账户打款方式。具体到账时间以收款银行到账时间为准。
      </p>
      <div>
        <div
          style="
            display: flex;
            align-items: center;
            gap: 24px;
            margin: 18px 0 10px;
          "
        >
          <span
            style="
              font-size: 14px;
              color: #121619;
              text-align: left;
              font-style: normal;
              text-transform: none;
            "
          >
            近3笔充值记录
          </span>
          <BaseButton type="text" @click="onMore">查看更多</BaseButton>
        </div>
        <BaseTable :data="rechargeData.rechargeList" :columns="columns" />
      </div>
    </BaseTextContent>

    <template #footer>
      <BaseButton type="default" @click="remove()">关闭</BaseButton>
    </template>
  </BaseDialog>
</template>

<script lang="tsx" name="account-main-recharge-dialog" setup>
import { withDefaults, defineProps, ref, onMounted } from 'vue';
import {
  BaseDialog,
  BaseTable,
  BaseTableProps,
  useTableColumn,
  BaseButton,
  useCreateModal,
  BaseForm,
  BaseTextContent,
  BaseFormItem,
  BaseInput
} from 'xrk-components';
import AccountMainRechargeRecordDialog from './account-main-recharge-record-dialog.vue';
import { rechargeInfo } from '../data-source/apis';
import { RechargeInfoData } from '../data-source/types';
import { PayPassagewayCode } from '@cTypes/bank';
import { formatter, http } from '@/utils';
import appStore from '@/store';
import { storeToRefs } from 'pinia';

const props = withDefaults(
  defineProps<{
    remove?: () => {};
    payPassagewayCode: PayPassagewayCode;
  }>(),
  {
    payPassagewayCode: 'fyBank',
    remove() {
      return () => {
        console.log('remove');
      };
    }
  }
);

const { info: userInfo } = storeToRefs(appStore.useUserStoreSetup);

const rechargeData = ref<RechargeInfoData>({
  companyName: '',
  bfBankNumber: '',
  openBankName: '',
  openBankNode: '',
  fySubBranchName: '',
  rechargeList: []
});

const onMore = () => {
  useCreateModal(AccountMainRechargeRecordDialog);
};

onMounted(async () => {
  const { data } = await rechargeInfo({
    payPassagewayCode: props.payPassagewayCode,
    functionCode: userInfo.value.functionCode,
    departmentId: userInfo.value.depId
  });
  rechargeData.value = data;
});

const columns: BaseTableProps['columns'] = [
  useTableColumn({
    type: 'index',
    label: '序号',
    width: '80px'
  }),
  useTableColumn({
    label: '打款账户名称',
    prop: 'bankAccName'
  }),
  useTableColumn({
    label: '打款账户号',
    prop: 'bfBankNumber'
  }),
  useTableColumn({
    label: '金额',
    prop: 'amount',
    formatter: ({ cellValue }) => formatter.fen2yuan(cellValue)
  }),
  useTableColumn({
    label: '流水号',
    prop: 'outTradeNo'
  }),
  useTableColumn({
    label: '日期',
    prop: 'finishPayDt',
    formatter: ({ cellValue }) => formatter.date(cellValue)
  }),
  useTableColumn({
    label: '操作',
    fixed: 'right',
    render: ({ row }) => {
      const { bankPayVoucherUrl } = row;
      return (
        <>
          {bankPayVoucherUrl && (
            <div>
              <BaseButton
                type="text"
                click={async () => {
                  await http.download({
                    url: bankPayVoucherUrl,
                    method: 'GET'
                  });
                }}
              >
                下载回执单
              </BaseButton>
            </div>
          )}
        </>
      );
    }
  })
];
</script>
